import script from "./WorksFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorksFilters.vue?vue&type=script&setup=true&lang=ts"

import "./WorksFilters.vue?vue&type=style&index=0&id=79b4b7e3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b4b7e3"]])

export default __exports__